import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentHYCSResendEmailSubmitOutput,
  type EnrollmentHYCSVerifyEmailData,
  type EnrollmentHYCSVerifyEmailSubmitOutput,
} from '../../../../models'

export const getEnrollmentHYCSVerifyEmailDataMock: EnrollmentHYCSVerifyEmailData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/verify-email',
  enrollmentData: {
    email: 'test@email.com',
    applicationId: '1234',
  },
}

export const submitEnrollmentHYCSVerifyEmailDataMock: EnrollmentHYCSVerifyEmailSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/disclosures',
}

export const submitEnrollmentHYCSResendEmailDataMock: EnrollmentHYCSResendEmailSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/verify-email',
}

export const mockGetEnrollmentHYCSVerifyEmailData = graphql.mutation('getEnrollmentHYCSVerifyEmailData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSVerifyEmailDataMock } })
})

export const mockSubmitEnrollmentHYCSVerifyEmailData = graphql.mutation('submitEnrollmentHYCSVerifyEmailData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSVerifyEmailDataMock } })
})

export const mockSubmitEnrollmentHYCSResendEmailData = graphql.mutation('submitEnrollmentHYCSResendEmailData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSResendEmailDataMock } })
})

export const mockEnrollmentHYCSVerifyEmail = [
  mockGetEnrollmentHYCSVerifyEmailData,
  mockSubmitEnrollmentHYCSVerifyEmailData,
  mockSubmitEnrollmentHYCSResendEmailData,
]
